<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500.05 90.18"
    ><defs
        ><style>
            .\32 edf37f2-a910-4944-8903-15c8209937a2 {
                fill: #a70230;
            }
            .\36 8a82abf-71b9-49d1-8ad3-5367a484c8df {
                fill: #1a171b;
            }
        </style></defs
    ><title>pei tel Logo RGB</title><g
        id="03b79434-5aa5-4469-b60a-5dcaff850962"
        data-name="Ebene 2"
        ><g id="422585fb-dae4-48b7-b153-362382a6c440" data-name="Ebene 1"
            ><path
                class="2edf37f2-a910-4944-8903-15c8209937a2"
                d="M220.21,77.6v-65a6.4,6.4,0,1,0-3.2,0v65a6.4,6.4,0,1,0,3.2,0Z"
            /><path
                class="68a82abf-71b9-49d1-8ad3-5367a484c8df"
                d="M17.25,39.06H56.15a6.51,6.51,0,0,0,4.59-1.77,5.57,5.57,0,0,0,1.9-4.23,5.72,5.72,0,0,0-1.9-4.24A6.4,6.4,0,0,0,56.15,27H13.29V69.21a5.54,5.54,0,0,1-1.94,4.28,6.78,6.78,0,0,1-4.7,1.75,6.77,6.77,0,0,1-4.7-1.75A5.54,5.54,0,0,1,0,69.21V27a11.15,11.15,0,0,1,3.88-8.51,13.44,13.44,0,0,1,9.41-3.55H56.15a20,20,0,0,1,14,5.28,16.81,16.81,0,0,1,0,25.41,21,21,0,0,1-14,5.49H30.53a13.49,13.49,0,0,1-9.39-3.53A11.1,11.1,0,0,1,17.25,39.06Z"
            /><path
                class="68a82abf-71b9-49d1-8ad3-5367a484c8df"
                d="M100.05,14.94H147a16.09,16.09,0,0,1,10.27,3.48A13.67,13.67,0,0,1,162.54,27H100.05V39.06h45.55a11.12,11.12,0,0,1-3.88,8.53,13.42,13.42,0,0,1-9.37,3.53h-32.3V63.18h62.49a13.61,13.61,0,0,1-5.28,8.6A16.15,16.15,0,0,1,147,75.24H100.05a13.59,13.59,0,0,1-9.43-3.51,11.33,11.33,0,0,1-4-8.55V27a11.35,11.35,0,0,1,4-8.53A13.55,13.55,0,0,1,100.05,14.94Z"
            /><path
                class="68a82abf-71b9-49d1-8ad3-5367a484c8df"
                d="M179.75,14.94a6.74,6.74,0,0,1,4.7,1.77A5.56,5.56,0,0,1,186.4,21V69.21a5.54,5.54,0,0,1-1.94,4.28,7.21,7.21,0,0,1-9.41,0,5.54,5.54,0,0,1-1.94-4.28V21A5.56,5.56,0,0,1,175,16.71,6.74,6.74,0,0,1,179.75,14.94Z"
            /><path
                class="2edf37f2-a910-4944-8903-15c8209937a2"
                d="M295.52,27.57V69.21a5.54,5.54,0,0,1-1.94,4.28,7.19,7.19,0,0,1-9.4,0,5.54,5.54,0,0,1-1.94-4.28V27.57H250.82V27a11.12,11.12,0,0,1,3.9-8.51,13.46,13.46,0,0,1,9.39-3.55h49.59a13.47,13.47,0,0,1,9.37,3.55A11.09,11.09,0,0,1,327,27v.58Z"
            /><path
                class="2edf37f2-a910-4944-8903-15c8209937a2"
                d="M350.87,14.94H397.8a16.08,16.08,0,0,1,10.27,3.48A13.68,13.68,0,0,1,413.36,27H350.87V39.06h45.55a11.13,11.13,0,0,1-3.88,8.53,13.43,13.43,0,0,1-9.37,3.53h-32.3V63.18h62.49a13.62,13.62,0,0,1-5.28,8.6,16.14,16.14,0,0,1-10.27,3.46H350.87a13.58,13.58,0,0,1-9.43-3.51,11.32,11.32,0,0,1-4-8.55V27a11.35,11.35,0,0,1,4-8.53A13.54,13.54,0,0,1,350.87,14.94Z"
            /><path
                class="2edf37f2-a910-4944-8903-15c8209937a2"
                d="M430.57,14.94a6.75,6.75,0,0,1,4.7,1.77A5.57,5.57,0,0,1,437.21,21V63.18H500a11.08,11.08,0,0,1-3.92,8.53,13.51,13.51,0,0,1-9.37,3.53H437.21a13.49,13.49,0,0,1-9.39-3.53,11.09,11.09,0,0,1-3.9-8.53V21a5.56,5.56,0,0,1,1.94-4.26A6.75,6.75,0,0,1,430.57,14.94Z"
            /></g
        ></g
    ></svg
>
